module.exports = __webpack_public_path__ + "img/gb889.prt.542f7423.jpg";